import {
  SET_SEARCH_CRITERIA,
  SET_SERIES_TYPE_ID,
  SET_SERIES_TYPE_DETAIL_ID,
  SET_PERIODICITY_ID,
  SET_PARENT_OBJECT_TYPE_ID,
  SET_IS_ACTIVE
} from './actions';

export const initialState = {
  searchCriteria: '',
  seriesTypeId: 1,
  seriesTypeDetailId: 1,
  periodicityId: 1,
  parentObjectTypeId: null,
  isActive: true
};

// TODO: Add actions for other advanced search criterias, and handle them in reducer
export const reducer = (state, action) => {
  switch (action.type) {
    case SET_SEARCH_CRITERIA:
      return {
        ...state,
        searchCriteria: action.payload
      };
    case SET_SERIES_TYPE_ID:
      return {
        ...state,
        seriesTypeId: action.payload
      };
    case SET_SERIES_TYPE_DETAIL_ID:
      return {
        ...state,
        seriesTypeDetailId: action.payload
      };
    case SET_PERIODICITY_ID:
      return {
        ...state,
        periodicityId: action.payload
      };
    case SET_PARENT_OBJECT_TYPE_ID:
      return {
        ...state,
        parentObjectTypeId: action.payload
      };
    case SET_IS_ACTIVE:
      return {
        ...state,
        isActive: action.payload
      };
    default:
      return state;
  }
};
